import React from 'react';
import Avatar from '@mui/material/Avatar';
import { getStudentAvatar } from '../../shared/studentAvatar';
import { fullName } from './studyDashboard';

export default function StudyStudentAvatar({ student, size = 44 }) {
  const theme = getStudentAvatar(student.id);
  return <Avatar
    className="wr-student-avatar"
    aria-label={`${fullName(student)} hayvan avatarı`}
    sx={{ width: size, height: size, bgcolor: theme.bgColor, borderColor: theme.borderColor, fontSize: size * 0.52 }}
  >{theme.avatar}</Avatar>;
}
